import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { StockPage } from '@/features/inventory/pages/stock-page';

/** `?lowOnly=true` is where the low-stock bell notification lands. */
export const Route = createFileRoute('/_app/inventory/stock')({
  validateSearch: z.object({
    lowOnly: z.enum(['true']).optional().catch(undefined),
  }),
  component: StockPage,
});
